import React from 'react';
import { NewDealInvestorsPanel } from './investorsPanel';
import ConnectorDeals from './ConnectorDeals';
import { ConnectorDealStatus } from '../../../types/types';
import { useConnectorDeals } from '../../../contexts';


const ConnectorDealsNew = () => {
  const { newDeals, newDealsTotalCount } = useConnectorDeals();

  return (
    <ConnectorDeals
      renderRightPanelContent={(deal) => (<NewDealInvestorsPanel deal={deal} />)}
      status={ConnectorDealStatus.New}
      deals={newDeals}
      totalCount={newDealsTotalCount}
    />
  );
};

export default ConnectorDealsNew;
